import React, { Component } from 'react';
import "./Content.css";
import DashboardOne from './sub-content/Dashboard-1';
import DashboardTwo from './sub-content/Dashboard-2';
import DashboardThree from './sub-content/Dashboard-3';
import Dashboardfour from './sub-content/Dashboard-4';

export class Content extends Component {
  render() {
    return (
      <div className="container usermain subdashboardmaincontent">
        <div className="row">
          <div className="col-4">
            < DashboardOne />
          </div>

          <div className="col-8">
            < DashboardTwo />
          </div>

          <div className="col-4 dashboard-three-main">
            < DashboardThree />
          </div>

          <div className="col-8">
            < Dashboardfour />
          </div>
          
        </div>
      </div>
    )
  }
}

export default Content;